module.exports = __webpack_public_path__ + "img/clear-night.c56e5f35.svg";